export default __webpack_public_path__ + "img/loginbg.5f529082.jpg";